import Collections from '@/pages/Collections'

export default {
    path: '/collections',
    name: 'Collections',
    component: Collections
}


// WEBPACK FOOTER //
// ./src/router/collections.js